import { render, staticRenderFns } from "./TrainLayout.vue?vue&type=template&id=3f31ba49&scoped=true"
import script from "./TrainLayout.vue?vue&type=script&lang=js"
export * from "./TrainLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f31ba49",
  null
  
)

export default component.exports